import { Box } from '@mui/material'
import { appUserColsMap, AppUserListColumns } from 'components/core/app-user/C1AppUsersList'
import { C1TableRedux } from 'components/core/list/C1Table/C1TableRedux'
import List from 'components/core/list/index'
import { useErrorReporting } from 'components/no-ui/error-reporting/datadog'
import { QUERIES } from 'components/pages/explore/query/Query'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { HighRiskUsersAndGrantsRequest } from 'pbts/c1/api/app/v1/app_user'
import { ExportDataRequest, QueryId } from 'pbts/c1/api/exportdata/v1/exportdata'
import { FC, useCallback, useMemo, useState } from 'react'
import { searchHighRiskUsersAndGrants } from 'redux_toolkit/app-users'
import { ExportData } from './ExportData'
import { StructuredSearchStyles } from './styles'

const droppedCols = [
    appUserColsMap[AppUserListColumns.account],
    appUserColsMap[AppUserListColumns.app],
    appUserColsMap[AppUserListColumns.status],
    appUserColsMap[AppUserListColumns.accountType],
    appUserColsMap[AppUserListColumns.user],
    appUserColsMap[AppUserListColumns.roles],
    appUserColsMap[AppUserListColumns.lastLogin],
]

export const HighRiskAccountsReport: FC = () => {
    const [page, setPage] = useState<number>(0)

    const { data, isError, isLoading, error, canLoadMore, getPage } = searchHighRiskUsersAndGrants.useHighRiskUsersAndGrants(
        HighRiskUsersAndGrantsRequest.create({ expandMask: { paths: ['*'] } }),
        {},
    )

    const onPageChange = useCallback(
        async (n: number) => {
            await getPage(n)
            setPage(n)
        },
        [getPage],
    )

    const exportDataActionRequest = useMemo(() => {
        return ExportDataRequest.create({
            queryId: QueryId.HIGH_RISK_ACCOUNTS,
            request: {
                oneofKind: 'highRiskRolesAndGrantsRequest',
                highRiskRolesAndGrantsRequest: HighRiskUsersAndGrantsRequest.create({ expandMask: { paths: ['*'] } }),
            },
        })
    }, [])

    useErrorReporting(isError, error, QUERIES.HighRiskAccounts)

    const table = useMemo(
        () => (
            <C1TableRedux
                data={data}
                cols={droppedCols}
                isError={isError}
                isLoading={isLoading}
                error={error}
                page={page}
                canLoadMore={canLoadMore}
                onPageChange={onPageChange}
            />
        ),
        [canLoadMore, data, error, isError, isLoading, onPageChange, page],
    )

    return <>
        <Box sx={StructuredSearchStyles.exportDataBox}>
            <ExportData exportDataRequest={exportDataActionRequest} />
        </Box>
        <List<AppUserValue> table={table} />
    </>
}
